import { apiSlice } from '../api/api-slice';
import { ResultDto } from '../api/models';

/**
 * EntityType values accepted by sp_DeleteMasterData. These strings are matched
 * case-insensitively by the stored procedure, but are kept in its spelling here.
 */
export type MasterDataEntityType =
  | 'Customers'
  | 'EndSystems'
  | 'ProfileMaps'
  | 'ConnectionEndPoints'
  | 'SourceTypes'
  | 'TargetTypes'
  | 'TransactionTypes'
  | 'CodeDecodeTypes'
  | 'CodeDecodeValues'
  | 'CodeDecodeMaps'
  | 'AcknowledgmentOverrides'
  | 'AcknowledgementReconciliationReports';

/** RTK Query cache tags matching the master data entities above. */
export type MasterDataTagType =
  | 'Customer'
  | 'EndSystem'
  | 'ProfileMap'
  | 'ConnectionEndPoint'
  | 'SourceType'
  | 'TargetType'
  | 'TransactionType'
  | 'CodeDecodeType'
  | 'CodeDecodeValue'
  | 'CodeDecodeMap'
  | 'AcknowledgmentOverride'
  | 'AcknowledgmentOverrideReportEmail'
  | 'AcknowledgmentOverrideReportEmailFilter';

export interface DeleteMasterDataRequest {
  masterdata: {
    Id: number;
    entityType: MasterDataEntityType;
    updatedBy: string;
    /** Cache tag to invalidate for the list this row belongs to. */
    tagType: MasterDataTagType;
    /** Extra tags to invalidate when the delete cascades, e.g. a type taking its values. */
    alsoInvalidates?: MasterDataTagType[];
  };
}

export const masterDataApi = apiSlice.injectEndpoints({
  endpoints(builder) {
    return {
      deleteMasterData: builder.mutation<ResultDto, DeleteMasterDataRequest>({
        query: ({ masterdata }) => {
          return {
            url: `/masterData/${masterdata.Id}`,
            method: 'DELETE',
            body: {
              entityType: masterdata.entityType,
              userName: masterdata.updatedBy,
            },
          };
        },
        invalidatesTags: (_data, _error, arg) => [
          { type: arg.masterdata.tagType, id: `${arg.masterdata.Id}` },
          arg.masterdata.tagType,
          ...(arg.masterdata.alsoInvalidates || []),
        ],
      }),
    };
  },
});

export const { useDeleteMasterDataMutation } = masterDataApi;
